<template>
	<div class="c-enrollment-login-block" :class="{ 'c-hcp-login-modal__login-wrapper': isHcpLoginModal }">
		<img
			v-if="isHcpLoginModal && vm.BaseViewModel.LogoImage"
			:src="vm.BaseViewModel.LogoImage"
			alt="Logo"
			class="c-hcp-login-modal__logo"
		/>
		<slot></slot>
		<div
			v-if="vm.CurrentBlock.Description"
			class="c-editorial"
			:class="{ 'c-hcp-login-modal__description': isHcpLoginModal }"
			v-html="formattedDescription"
		></div>
		<div v-if="isHcpLoginModal" class="c-hcp-login-modal__button-block">
			<a
				:href="vm.BaseViewModel.RegistrationPageUrl"
				class="e-button e-button--filled c-hcp-login-modal__button"
				@click="trackUserEvent('register'); track_sign_up_start()"
			>
				{{ vm.CurrentBlock.RegistrationButtonText }}
			</a>
		</div>
		<div v-if="!isHcpLoginModal" class="c-enrollment-button-login" :class="[vm.CurrentBlock.ButtonAlignment]">
			<a class="e-button e-button--filled clickable-link h-nowrap" :href="vm.BaseViewModel.LoginUri" @click="track_login_start()">
				{{ vm.CurrentBlock.LoginButtonText }}
			</a>
		</div>
		<div v-if="isHcpLoginModal && vm.CurrentBlock.LoginLabelText" class="c-hcp-login-modal__login-block">
			<span>{{ vm.CurrentBlock.LoginLabelText }}</span>
			<a
				:href="vm.BaseViewModel.LoginUri"
				class="c-hcp-login-modal__link"
				@click="trackUserEvent('login'); track_login_start()"
			>
				{{ vm.CurrentBlock.LoginButtonText }}
			</a>
		</div>
	</div>
</template>

<script>
	import { track_gated_content_choice } from 'shared/services/tracking/contentTrackingService';
	import { track_login_start, track_sign_up_start } from 'shared/services/tracking/loginTrackingService.ts';

	export default {
		name: 'hcp-login-block',
		props: ['vm'],
		computed: {
			isHcpLoginModal() {
				return this.vm.CurrentBlock.IsHcpLoginModal === 'True';
			},
			formattedDescription() {
				if (this.vm.CurrentBlock.Description?.includes('$link$')) {
					return this.vm.CurrentBlock.Description.replace(
						'$link$',
						`<a href="${this.vm.BaseViewModel.ConsentPageUrl}" target="_blank">${this.vm.CurrentBlock.ConsentLinkText}</a>`
					);
				} else {
					return this.vm.CurrentBlock.Description;
				}
			},
		},
		methods: {
			trackUserEvent(choice) {
				// new GA4 tracking:

				track_gated_content_choice(choice);
			},
			track_login_start,
			track_sign_up_start,
		},
	};
</script>
